<template>
	<v-container>
		<Register/>
	</v-container>
</template>

<script>
import Register from '@/components/Register.vue';

export default {
  name: 'RegisterPage',
  
  components: {
    Register
  },

  data() {
    return {
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    }
  },
  created() {
    
  },
  mounted() {
    /*let fontAwesome = document.createElement('script')
      fontAwesome.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/js/all.min.js')
      document.head.appendChild(fontAwesome);*/


    if (this.loggedIn) {
      this.$router.push('/');
    }
  },
  methods: {
	goToHomePage() {
      this.$router.push('/');
    },
  }
};
</script>